<template>
  <el-card shadow="hover" class="filters-card">
    <div slot="header" class="el-row el-align-middle el-justify-space-between">
      <span>Filters</span>
      <el-button
        type="text"
        size="small"
        class="pull-right"
        @click="resetFilters"
        icon="el-icon-refresh-left"
      >
        Clear All
      </el-button>
    </div>

    <div class="filter-section">
      <h4>Quick Filters</h4>
      <el-button
        v-for="filter in quickFilters"
        :key="filter.label"
        :type="filter.active ? 'primary' : ''"
        size="small"
        @click="toggleFilters(filter)"
        style="margin: 4px 4px 4px 0; min-width: 100px; text-align: center"
      >
        <i :class="filter.icon"></i> {{ filter.label }}
      </el-button>
    </div>

    <div class="filter-section">
      <h4>Minimum Score</h4>
      <el-rate
        v-model="filters.minScore"
        :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
        :texts="['Poor', 'Fair', 'Average', 'Good', 'Excellent']"
        show-text
        @change="applyFilters"
      />
    </div>

    <div class="filter-section">
      <h4>Tone / Emotion</h4>
      <el-checkbox-group v-model="filters.selectedTones" @change="applyFilters">
        <el-checkbox
          v-for="tone in toneOptions"
          :key="tone.value"
          :label="tone.label"
          class="d-block mb-1"
        >
          {{ capitalize(tone.label) }}
        </el-checkbox>
      </el-checkbox-group>
    </div>

    <div class="filter-section">
      <h4>Tags</h4>
      <el-select
        v-model="filters.selectedTags"
        multiple
        placeholder="Select tags"
        style="width: 100%"
        @change="applyFilters"
      >
        <el-option v-for="tag in tagOptions" :key="tag" :label="tag" :value="tag" />
      </el-select>
    </div>

    <div class="filter-section">
      <h4>Max Length (seconds)</h4>
      <el-slider
        v-model="filters.maxLength"
        :max="120"
        :step="5"
        show-stops
        @change="applyFilters"
      />
      <div class="text-center mt-1">{{ filters.maxLength }}s</div>
    </div>

    <div class="mt-4 pt-3 border-top">
      <span><i class="fa fa-fw fa-star"></i> Trending Topics</span>
      <div class="cloud-wrapper">
        <cloud
          :data="wordCloudData"
          :fontSizeMapper="fontSizeMapper"
          :padding="3"
          width="250"
          height="150"
        />
      </div>
    </div>
  </el-card>
</template>

<script>
import Cloud from 'vue-d3-cloud';
import { capitalize } from 'lodash';

export default {
  name: 'FiltersSidebar',
  components: { Cloud },
  props: {
    transcripts: { type: Array, required: true },
    toneOptions: { type: Array, required: true },
    tagOptions: { type: Array, required: true },
  },
  data() {
    return {
      quickFilters: [
        { label: 'Score ≥ 4', icon: 'fa fa-star', active: false, filter: t => t.score >= 4 },
        {
          label: 'Approved On Air',
          icon: 'fa fa-podcast',
          active: false,
          filter: t => t.approved,
        },
        {
          label: 'Needs Review',
          icon: 'fa fa-exclamation-circle',
          active: false,
          filter: t => t.flagged,
        },
        {
          label: 'Short (<30s)',
          icon: 'fa fa-clock-o',
          active: false,
          filter: t => t.audioDuration < 30,
        },
      ],
      filters: {
        minScore: 0,
        selectedTones: [],
        selectedTags: [],
        maxLength: 120,
      },
    };
  },
  methods: {
    capitalize,
    applyFilters() {
      const activeQuickFilters = this.quickFilters.filter(f => f.active).map(f => f.filter);
      this.$emit('apply-filters', { ...this.filters, quickFilters: activeQuickFilters });
    },
    resetFilters() {
      this.quickFilters = this.quickFilters.map(f => ({ ...f, active: false }));
      this.filters = { minScore: 0, selectedTones: [], selectedTags: [], maxLength: 120 };
      this.applyFilters();
    },
    toggleFilters(filter) {
      const updatedFilters = this.quickFilters.map(f => {
        if (f.label === filter.label) {
          return { ...f, active: !f.active };
        }
        return f;
      });
      this.quickFilters = updatedFilters;
      this.applyFilters();
    },
    fontSizeMapper: word => Math.log2(word.value) * 12,
  },
  computed: {
    wordCloudData() {
      const allWords = this.transcripts.flatMap(t => [...(t.keywords || []), ...(t.topics || [])]);

      const counts = allWords.reduce((acc, word) => {
        if (!word) return acc;
        const key = word.toLowerCase();
        acc[key] = (acc[key] || 0) + 1;
        return acc;
      }, {});

      return Object.entries(counts).map(([text, value]) => ({
        text: text.charAt(0).toUpperCase() + text.slice(1),
        value,
      }));
    },
  },
};
</script>

<style scoped>
.cloud-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.filters-card {
  position: sticky;
  top: 20px;
}
.filter-section {
  margin-bottom: 20px;
}
.filter-section h4 {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
}
.text-info {
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// FiltersSidebar.vue?63cd9b6b